import { gql } from '@apollo/client';

export default gql`
  query currentMembership {
    currentMembership {
      id
      status
      billingFrequency
      nextBillDate
      nextBillAmount
      billing {
        card {
          brand
          last4
          expDate
        }
      }
      productName
      membershipEditable
      paymentGateway
    }
  }
`;
